import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

type resourceTypes = 'html' | 'style' | 'script' | 'url' | 'resourceUrl';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'safe',
  standalone: false,
})
export class SafePipe implements PipeTransform {
  /**
   * Pipe Constructor
   *
   * @param sanitizer: DomSanitizer
   */
  constructor(protected sanitizer: DomSanitizer) {
  }

  /**
   * Transform
   *
   * @param value: string
   * @param type: string
   */
  transform(value: string, type: resourceTypes): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value) as string;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
  }
}
